import React, { useEffect, useState } from "react";
import { storageService } from "../../services/storageService";

const AvatarDisplay = ({ showName, avatar, avatarData: avatarDataProp }) => {
  const [avatarData, setAvatarData] = useState(null);

  useEffect(() => {
    const storedAvatar = localStorage.getItem("childAvatar");
    const parsedAvatar = storedAvatar ? JSON.parse(storedAvatar) : null;
    const sourceAvatar = avatar || avatarDataProp || parsedAvatar || avatarData;
    if (sourceAvatar) { setAvatarData(sourceAvatar); }
  }, [avatar, avatarDataProp]);

  useEffect(() => {
    const handleStorageChange = () => {
      const userData = storageService.getChildData();
      setAvatarData(userData?.avatar || null);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  if (!avatarData) return null;

  const useDotOne =
    avatarData.genderId === 1 &&
    (avatarData.hair === 0 || avatarData.hair === 3);
  const withoutPants =
    (avatarData.genderId === 0 && avatarData.shirt === 2) ||
    (avatarData.genderId === 1 && avatarData.shirt === 3);

  const suffixFrontHair = useDotOne ? ".1.svg" : ".svg";
  const suffixBackHair = useDotOne ? ".2.svg" : ".svg";

  const imagePathFrontHair = `/assets/avatar/${avatarData.gender}/hairs/${
    avatarData.gender
  }Hair${avatarData.hair + 1}${suffixFrontHair}`;
  const imagePathBackHair = `/assets/avatar/${avatarData.gender}/hairs/${
    avatarData.gender
  }Hair${avatarData.hair + 1}${suffixBackHair}`;

  return (
    <div className="relative w-full h-full">
      <div className="relative w-full h-full">
        {avatarData.hair + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={imagePathBackHair}
              alt="Back Hair"
              hidden={!useDotOne}
            />
          </div>
        )}

        {avatarData.skin + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/skins/${
                avatarData.gender
              }Skin${avatarData.skin + 1}.svg`}
              alt="Skin"
            />
          </div>
        )}

        {avatarData.eyes + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/eyes/${
                avatarData.gender
              }Eyes${avatarData.eyes + 1}.svg`}
              alt="Skin"
            />
          </div>
        )}

        {avatarData.hair + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={imagePathFrontHair}
              alt="Hair"
            />
          </div>
        )}

        {avatarData.mouth + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/mouths/${
                avatarData.gender
              }Mouth${avatarData.mouth + 1}.svg`}
              alt="Mouth"
            />
          </div>
        )}

        {avatarData.shoes + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/shoes/${
                avatarData.gender
              }Shoes${avatarData.shoes + 1}.svg`}
              alt="Shoes"
            />
          </div>
        )}

        {avatarData.pants + 1 > 0 && !withoutPants && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/pants/${
                avatarData.gender
              }Pants${avatarData.pants + 1}.svg`}
              alt="Pants"
            />
          </div>
        )}

        {avatarData.shirt + 1 > 0 && (
          <div className="absolute inset-0 w-full h-full">
            <img
              className="w-full h-full"
              src={`/assets/avatar/${avatarData.gender}/shirts/${
                avatarData.gender
              }Shirt${avatarData.shirt + 1}.svg`}
              alt="Shirt"
            />
          </div>
        )}
      </div>

      {avatarData.name && showName && (
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
          <div className="bg-white px-3 py-1 rounded-full shadow text-center">
            <p className="font-bold text-sm">{localStorage.getItem("childNombre")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarDisplay;